import { LocalDate } from 'js-joda';
import { createSelector } from 'reselect';
import { oc } from 'ts-optchain';

import { StoreType } from '@tock/shared/utils/connect';
import { createDeepEqualSelector } from 'utils/service/selectorUtils';
import { fastParseDate } from 'utils/timeUtils';

export const serviceAppSelector = createSelector(
  (state: StoreType) => state.service.app,
  (app) => app
);

export const historyToggledOnSelector = createSelector(
  serviceAppSelector,
  (app): boolean | undefined => app.historyToggledOn
);

export const serviceIsReadOnlySelector = createSelector(serviceAppSelector, (app): boolean =>
  oc(app).isReadOnly(false)
);

export const serviceEverConnectedSelector = createSelector(serviceAppSelector, (app): boolean =>
  oc(app.currentTopic).everConnected(false)
);

export const serviceTopicSelector = createDeepEqualSelector(
  (state: StoreType) => oc(state).service.app.currentTopic(),
  (currentTopic) => currentTopic
);

export const serviceDateSelector = createSelector(
  serviceTopicSelector,
  (currentTopic): string | undefined => {
    return currentTopic?.serviceDate;
  }
);

export const parsedServiceDateSelector = createSelector(
  serviceTopicSelector,
  (currentTopic): LocalDate | undefined => {
    return currentTopic && fastParseDate(currentTopic.serviceDate);
  }
);
